export const DS_COPY_BUTTON_CLASSES = {
  Root: "ds-copy-button",
} as const;
